import _ from 'lodash';
import { useEffect } from 'react';

/**
 * Custom hook to set global model execution ids in nwa.
 * @param {String} [modelExecutionIds]
 */
export const useSetGlobalModelExecutionIds = (modelExecutionIds) => {
  const propName = 'modelExecutionIds';

  useEffect(() => {
    // This effect is irrelevant without the nwa tracking
    if (!window?.nwa || !modelExecutionIds?.length) return;

    const currentIds = window.nwa.getGlobalProp(propName) || [];
    window.nwa.setGlobalProp(
      propName,
      _.uniq([...currentIds, ...modelExecutionIds])
    );

    // eslint-disable-next-line consistent-return
    return () => {
      window.nwa.setGlobalProp(propName, currentIds);
    };
  }, [modelExecutionIds]);
};
